import onBrowser from "../../utils/onBrowser"

export const trackGatedDownload = () => {
  if (onBrowser) {
    // Track success Google
    if (window.gtag) {
      window.gtag("event", "Download", {
        event_action: "Download",
        event_category: "Whitepaper",
        event_label: "performance-tv-whitepaper",
      })
    }
    // Track success Facebook
    if (window.fbq) {
      window.fbq("track", "Lead")
    }

    // Track success Linkedin
    const id = "1142266"
    if (!document.getElementById(id)) {
      const linkedinTracker = document.createElement("img")
      linkedinTracker.id = id
      linkedinTracker.style.cssText = "display:none;"
      linkedinTracker.src =
        "https://px.ads.linkedin.com/collect/?pid=26376&conversionId=1142266&fmt=gif"
      document.body.appendChild(linkedinTracker)
    }
  }
}

export default {
  trackGatedDownload,
}
